'use client';

import { useMemo, useState } from 'react';
import { SizePassportContext } from './contexts/SizePassportContext';
import { SizePassportSelection } from '../utils/interfaces';

export type SizePassportContextProviderProps = {
  children: React.ReactNode;
  defaultToken?: string;
  defaultSizePassportSelection: SizePassportSelection;
};

export const SizePassportContextProvider = ({
  children,
  defaultToken,
  defaultSizePassportSelection,
}: SizePassportContextProviderProps) => {
  const [token, setToken] = useState<string | undefined>(defaultToken);
  const [tokenInjectionFailed, setTokenInjectionFailed] = useState(false);
  const [sizePassportSelection, setSizePassportSelection] =
    useState<SizePassportSelection>(defaultSizePassportSelection);
  const [spCorrelationId, setSpCorrelationId] = useState<string>(crypto.randomUUID());
  const contextValue = useMemo(() => {
    return {
      token,
      setToken,
      tokenInjectionFailed,
      setTokenInjectionFailed,
      sizePassportSelection,
      setSizePassportSelection,
      spCorrelationId,
      setSpCorrelationId,
    };
  }, [token, tokenInjectionFailed, sizePassportSelection, spCorrelationId]);

  return <SizePassportContext.Provider value={contextValue}>{children}</SizePassportContext.Provider>;
};
